export default {"src":"/_next/static/media/girl.68b8a8ca.svg","height":500,"width":500};